import {ConditionKind} from '../../enum/condition.kind';
import moment from 'moment';

export class NickCalculate {

    public static applyCondition(valueA: any, valueB: any, condition: ConditionKind): boolean {
        switch (condition) {
            case ConditionKind.DEFAULT:
                return true;
            case ConditionKind.IN:
                return valueB instanceof Array && valueB.indexOf(valueA) >= 0;
            case ConditionKind.NOTIN:
                return !valueB || (valueB instanceof Array && valueB.indexOf(valueA) == -1);
            case ConditionKind.ALWAYS:
                return true;
            case ConditionKind.ISTRUE:
                return (valueA instanceof Array) ? valueA.every(a => a === true) : valueA === true;
            case ConditionKind.ISFALSE:
                return (valueA instanceof Array) ? valueA.every(a => a === false) : valueA === false;
            case ConditionKind.NOTNULL:
            case ConditionKind.HASUSER:
                return valueA != undefined;
            case ConditionKind.ISNULLL:
            case ConditionKind.ISANONYMOUS:
                return valueA == undefined;
            case ConditionKind.ISEMPTY:
                return !!(valueA == undefined || (valueA instanceof Array && !valueA.length) || (!(typeof valueA == 'number') && !(typeof valueA == 'boolean') && (valueA.trim && valueA.trim() == '')));
            case ConditionKind.LIKE:
                return valueB.indexOf(valueA) >= 0;
            case ConditionKind.DIFF:
            case ConditionKind.NEQUALS:
            case ConditionKind.ISNOTGROUP:
            case ConditionKind.ISNOTCURRENTUSER:
                return valueA != valueB;
            case ConditionKind.ISGROUP:
            case ConditionKind.EQUALS:
            case ConditionKind.ISCURRENTUSER:
                return valueA == valueB;
            case ConditionKind.AFTER:
                return moment(valueA).isAfter(moment(valueB));
            case ConditionKind.BEFORE:
                return moment(valueA).isBefore(moment(valueB));
            case ConditionKind.AFTEROREQUALS:
                return moment(valueA).isSameOrAfter(moment(valueB));
            case ConditionKind.BEFOREOREQUALS:
                return moment(valueA).isSameOrBefore(moment(valueB));
            case ConditionKind.ISBETWEEN: {
                if (valueB instanceof Array && !isNaN(valueA)) {
                    return valueA >= valueB[0] && valueA <= valueB[1];
                }
                return valueB ? moment(valueB).isBetween(moment(valueA[0]), moment(valueA[1])) : moment().isBetween(moment(valueA[0]), moment(valueA[1]));
            }
            case ConditionKind.LTEQUALS:
                return (isNaN(valueA) ? 0 : parseFloat(valueA)) <= (isNaN(valueB) ? 0 : parseFloat(valueB));
            case ConditionKind.GTEQUALS:
                return (isNaN(valueA) ? 0 : parseFloat(valueA)) >= (isNaN(valueB) ? 0 : parseFloat(valueB));
            case ConditionKind.LT:
                return (isNaN(valueA) ? 0 : parseFloat(valueA)) < (isNaN(valueB) ? 0 : parseFloat(valueB));
            case ConditionKind.GT:
                return (isNaN(valueA) ? 0 : parseFloat(valueA)) > (isNaN(valueB) ? 0 : parseFloat(valueB));
            case ConditionKind.ISUUID:
                return /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(valueA);
            case ConditionKind.ISNUMBER:
                return !isNaN(valueA);
            case ConditionKind.ISNOTNUMBER:
                return isNaN(valueA);
            case ConditionKind.ISNOTEMPTY:
                return valueA != undefined && (!(valueA instanceof Array) || (valueA instanceof Array && valueA.length > 0)) && (!valueA.trim || valueA.trim() != '');
            case ConditionKind.CONTAINS:
                return valueB instanceof Array && valueB.indexOf(valueA) >= 0;
            case ConditionKind.REGEX_TEST:
                return new RegExp(valueB).test(valueA);

        }
    }

    public static flattenDeep(arr1: any[]): any[] {
        return arr1.reduce((acc, val) => Array.isArray(val) ? acc.concat(NickCalculate.flattenDeep(val)) : acc.concat(val), []);
    }
}
